<app-loading *ngIf="contentReady"></app-loading>
<div class="container-fluid p-0">
  <div class="d-sm-flex">


    <div class="col-12 col-sm-12 main-content">
      <div class="container-fluid mb-4">
        <div class="categoryContainer">
          <div>

          </div>
        </div>
        <div>
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

            <!-- Order ID -->
            <ng-container matColumnDef="order_id">
              <th mat-header-cell *matHeaderCellDef> {{'invoice'| transloco}} # </th>
              <td mat-cell *matCellDef="let element"> {{ element.order_id }} </td>
            </ng-container>

            <!-- City -->
            <ng-container matColumnDef="city">
              <th mat-header-cell *matHeaderCellDef> {{'area'| transloco}} </th>
              <td mat-cell *matCellDef="let element">
                {{ element.city?.city_name_ar || '-' }}
              </td>
            </ng-container>

            <!-- Governorate -->
            <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef> {{'address'| transloco}} </th>
              <td mat-cell *matCellDef="let element">
                {{ element.order?.address || '-' }}
              </td>
            </ng-container>

            <!-- Products -->
            <ng-container matColumnDef="products">
              <th mat-header-cell *matHeaderCellDef> {{'products'| transloco}} </th>
              <td mat-cell *matCellDef="let element">
                {{ element.products }}
              </td>
            </ng-container>

            <!-- Delete -->


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          </table>

          <mat-paginator [length]="total" [pageSize]="10" (page)="onPaginateChange($event)">
          </mat-paginator>



        </div>

        <div class="row">
          @if (noData) {
          <app-nodata></app-nodata>
          } @else {


          }
        </div>
      </div>
    </div>
  </div>
</div>